var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.getComp(_vm.tempactive),{tag:"component",attrs:{"temdata":_vm.temdata,"isFirst":_vm.isFirst}})
}
var staticRenderFns = []

export { render, staticRenderFns }